import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'
import { IUser } from 'redux/store/user/types'
import { ACTIONS, SUBJECTS } from '../Abilities/constants'
import {
  DashboardAbilityBuilder,
  DashboardAbility,
  PossibleAbilities,
  Conditions
} from './types'
import { ROLES } from 'features/Permission'
import { isInsideCommunityCondition } from 'features/Permission/abilities/conditions'

const MyOrganizationAbilityClass = Ability as AbilityClass<DashboardAbility>

export const ability = new Ability<PossibleAbilities, Conditions>()

export default (user: IUser) => {
  const builder = new AbilityBuilder(MyOrganizationAbilityClass)

  if (user.role.includes('community')) {
    defineCommunityAbilities(builder, user)
  }

  return new Ability(builder.rules) as DashboardAbility
}

const defineCommunityAbilities = (
  builder: DashboardAbilityBuilder,
  user: IUser
) => {
  builder.can(
    ACTIONS.VIEW,
    SUBJECTS.HEALTH_SYSTEM_COLUMN,
    isInsideCommunityCondition
  )

  if (user.role === ROLES.CONTRACT_STEWARD) {
    builder.can(ACTIONS.VIEW, SUBJECTS.FILTERS)
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER,
      isInsideCommunityCondition
    )
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER_MULTISELECT,
      isInsideCommunityCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.PORTFOLIO_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.CC_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.LED_BY_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.EXPECTED_SAVINGS_MENU)
    builder.can(ACTIONS.VIEW, SUBJECTS.MY_HEALTH_SYSTEM_LABEL)
  }
  if (user.role === ROLES.ANALYST || user.role === ROLES.CLINICAL_COORDINATOR) {
    builder.can(ACTIONS.VIEW, SUBJECTS.FILTERS)
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER,
      isInsideCommunityCondition
    )
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER_MULTISELECT,
      isInsideCommunityCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.PORTFOLIO_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.CC_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.LED_BY_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.USER_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.HEALTH_SYSTEMS_PREDEFINED)
    if (user.role === ROLES.ANALYST) {
      builder.can(ACTIONS.VIEW, SUBJECTS.EXPECTED_SAVINGS_MENU)
    }
  }
  if (
    user.role === ROLES.VICE_PRESIDENT ||
    user.role === ROLES.FINANCE ||
    user.role === ROLES.COMMUNITY_PRESIDENT
  ) {
    builder.can(ACTIONS.VIEW, SUBJECTS.FILTERS)
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER,
      isInsideCommunityCondition
    )
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.HEALTH_SYSTEMS_FILTER_MULTISELECT,
      isInsideCommunityCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.PORTFOLIO_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.CC_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.LED_BY_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.USER_FILTER)
    builder.can(ACTIONS.VIEW, SUBJECTS.HEALTH_SYSTEMS_PREDEFINED)
    builder.can(ACTIONS.VIEW, SUBJECTS.EXPECTED_SAVINGS_MENU)
    if (user.role === ROLES.VICE_PRESIDENT) {
      builder.can(ACTIONS.VIEW, SUBJECTS.MY_HEALTH_SYSTEM_LABEL)
    }
  }

  if (user.role === ROLES.COMMUNITY_PRESIDENT) {
    builder.can(ACTIONS.VIEW, SUBJECTS.EXPECTED_SAVINGS_MENU)
  }
}
